/* src/app/centrui/src/app/components/intro/intro.component.scss */
button.tutorial {
  position: relative;
  border: 0;
  background-color: transparent;
  width: 52px;
  height: 40px;
  display: block;
  outline: none;
}
button.tutorial .question-mark {
  background: url("./media/help-circle.svg") no-repeat center center;
  width: 40px;
  height: 40px;
  display: block;
}
button.tutorial:hover,
button.tutorial:active,
button.tutorial:focus {
  outline: none;
}
::ng-deep .introjs-tour {
  z-index: 10040005;
}
::ng-deep .introjs-helperLayer {
  background-color: transparent;
  z-index: 10040006;
}
::ng-deep .introjs-overlay {
  z-index: 10040005;
}
::ng-deep .introjs-showElement {
  z-index: 10040007 !important;
}
::ng-deep .introjs-disableInteraction {
  z-index: 10040008;
}
::ng-deep .menu {
  z-index: 10040009 !important;
}
::ng-deep .introjs-tooltipReferenceLayer {
  z-index: 10040010;
}
::ng-deep .introjs-helperNumberLayer {
  background: #DB2121;
  z-index: 10040010;
}
::ng-deep .introjs-tooltip .introjs-button {
  background: #1E31BF;
  border-color: #FFFFFF;
  color: #FFFFFF;
  text-shadow: none;
  border-radius: 5px !important;
  padding: 7.5px 15px !important;
}
::ng-deep .introjs-tooltip .introjs-button.introjs-prevbutton {
  background-color: rgba(30, 49, 191, 0.04) !important;
  color: #1E31BF;
}
::ng-deep .introjs-tooltip .introjs-button:hover {
  cursor: pointer;
}
button.tutorial .question-mark.rdu {
  background: url("./media/help-circle.svg") no-repeat center center;
  width: 30px;
  height: 40px;
}
::ng-deep .introjs-tooltiptext {
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #000000;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
}
::ng-deep .introjs-tooltip-title {
  font-family: "PoppinsBold";
  font-size: 16px;
  color: black;
  padding: 0.125rem;
}
::ng-deep .introjs-tooltip-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}
::ng-deep .introjs-tooltip .introjs-button {
  font-family: "PoppinsBold";
  color: white;
}
::ng-deep .introjs-helperLayer {
  background-color: transparent !important;
  z-index: 10040006;
  box-shadow: rgba(30, 49, 191, 0.4) 0 0 1px 2px, rgba(30, 49, 191, 0.4) 0 0 0 5000px !important;
}
::ng-deep body.intro-preaction-pending .introjs-helperLayer,
::ng-deep body.intro-preaction-pending .introjs-tooltip,
::ng-deep body.intro-preaction-pending .introjs-tooltipReferenceLayer,
::ng-deep body.intro-preaction-pending .introjs-overlay {
  visibility: hidden !important;
}
::ng-deep .introjs-tooltip {
  border: 0.0625rem solid #EBEBEB;
  border-radius: 5px;
  box-shadow: 0rem 0.1875rem 0.1875rem rgba(0, 0, 0, 0.13), 0rem 0.3125rem 0.625rem rgba(0, 0, 0, 0.09);
}
::ng-deep .introjs-tooltip.intro-next-tours-host-top,
::ng-deep .introjs-tooltip.intro-next-tours-host-bottom,
::ng-deep .introjs-tooltip.intro-next-tours-host-left,
::ng-deep .introjs-tooltip.intro-next-tours-host-right {
  overflow: visible !important;
  box-sizing: border-box;
}
::ng-deep .introjs-tooltip.intro-next-tours-host-top {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
::ng-deep .introjs-tooltip.intro-next-tours-host-bottom {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::ng-deep .introjs-tooltip.intro-next-tours-host-left {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
::ng-deep .introjs-tooltip.intro-next-tours-host-right {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::ng-deep .intro-next-tours {
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  background: #FFFFFF;
  border: 0.0625rem solid #EBEBEB;
  box-shadow: none;
}
::ng-deep .intro-next-tours.intro-next-tours--bottom {
  top: calc(100% - 5px);
  left: -0.0625rem;
  right: -0.0625rem;
  border-top: 0;
  padding-top: 0.5rem;
  border-radius: 0 0 5px 5px;
}
::ng-deep .intro-next-tours.intro-next-tours--top {
  bottom: calc(100% - 5px);
  left: -0.0625rem;
  right: -0.0625rem;
  border-bottom: 0;
  padding-bottom: 0.5rem;
  border-radius: 5px 5px 0 0;
}
::ng-deep .intro-next-tours.intro-next-tours--right,
::ng-deep .intro-next-tours.intro-next-tours--left {
  display: flex;
  flex-direction: column;
  overflow: visible;
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
}
::ng-deep .intro-next-tours.intro-next-tours--right {
  left: 100%;
  top: -0.0625rem;
  bottom: -0.0625rem;
  width: 16rem;
  padding-left: 0.5rem;
  border-left: 0;
  border-radius: 0 5px 5px 0;
}
::ng-deep .intro-next-tours.intro-next-tours--left {
  right: 100%;
  top: -0.0625rem;
  bottom: -0.0625rem;
  width: 16rem;
  padding-right: 0.5rem;
  border-right: 0;
  border-radius: 5px 0 0 5px;
}
::ng-deep .intro-next-tours::before,
::ng-deep .intro-next-tours::after {
  content: "";
  position: absolute;
  pointer-events: none;
}
::ng-deep .intro-next-tours::after {
  z-index: 1;
  background: #e0e0e0;
}
::ng-deep .intro-next-tours.intro-next-tours--left::before,
::ng-deep .intro-next-tours.intro-next-tours--right::before {
  top: 0;
  bottom: 0;
  width: 5px;
  background: #FFFFFF;
}
::ng-deep .intro-next-tours.intro-next-tours--left::before {
  left: 100%;
}
::ng-deep .intro-next-tours.intro-next-tours--right::before {
  right: 100%;
}
::ng-deep .intro-next-tours.intro-next-tours--left::after {
  top: 0;
  bottom: 0;
  right: 0;
  width: 1px;
}
::ng-deep .intro-next-tours.intro-next-tours--right::after {
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
}
::ng-deep .intro-next-tours.intro-next-tours--bottom::after {
  left: 0;
  right: 0;
  top: 5px;
  height: 1px;
}
::ng-deep .intro-next-tours.intro-next-tours--top::after {
  left: 0;
  right: 0;
  bottom: 5px;
  height: 1px;
}
::ng-deep .intro-next-tours .intro-next-tours-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin: 0 0.375rem 0.375rem;
  padding: 0.25rem;
  min-height: 2rem;
}
::ng-deep .intro-next-tours .intro-next-tours-header.search-expanded .intro-next-tours-heading {
  opacity: 0;
  transform: translateX(-0.5rem);
  visibility: hidden;
  pointer-events: none;
}
::ng-deep .intro-next-tours .intro-next-tours-header.search-expanded .intro-next-tours-search {
  opacity: 1;
  transform: translateX(0);
  visibility: visible;
  pointer-events: auto;
}
::ng-deep .intro-next-tours .intro-next-tours-header-main {
  position: relative;
  flex: 1;
  min-width: 0;
  height: 2rem;
}
::ng-deep .intro-next-tours .intro-next-tours-heading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 0.25rem;
  font-family: "PoppinsSemi Bold";
  font-size: 0.75rem;
  line-height: 1rem;
  color: #757575;
  opacity: 1;
  transform: translateX(0);
  transition:
    opacity 200ms ease-in-out,
    transform 200ms ease-in-out,
    visibility 200ms ease-in-out;
  visibility: visible;
  pointer-events: auto;
}
::ng-deep .intro-next-tours .intro-next-tours-search-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 0.375rem;
  background: transparent;
  cursor: pointer;
  transition: background 200ms ease-in-out;
}
::ng-deep .intro-next-tours .intro-next-tours-search-toggle svg {
  width: 1.125rem;
  height: 1.125rem;
  fill: #757575;
  transition: transform 200ms ease-in-out;
}
::ng-deep .intro-next-tours .intro-next-tours-search-toggle:hover,
::ng-deep .intro-next-tours .intro-next-tours-search-toggle:focus-visible {
  background: #F7F8FC;
  outline: none;
}
::ng-deep .intro-next-tours .intro-next-tours-search {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.75rem;
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.5rem;
  background: #FFFFFF;
  opacity: 0;
  transform: translateX(0.5rem);
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 200ms ease-in-out,
    transform 200ms ease-in-out,
    visibility 200ms ease-in-out,
    border-color 200ms ease-in-out;
}
::ng-deep .intro-next-tours .intro-next-tours-search:focus-within {
  border-color: #1E31BF;
}
::ng-deep .intro-next-tours .intro-next-tours-search .intro-next-tours-search-icon {
  flex-shrink: 0;
  width: 1.125rem;
  height: 1.125rem;
  fill: #757575;
}
::ng-deep .intro-next-tours .intro-next-tours-search .intro-next-tours-search-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  box-shadow: none;
  font-family: "PoppinsRegular";
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: #757575;
}
::ng-deep .intro-next-tours .intro-next-tours-search .intro-next-tours-search-input::placeholder {
  color: #AAAAAA;
}
::ng-deep .intro-next-tours .intro-next-tours-empty-message {
  margin: 0 0.5rem 0.5rem;
  text-align: center;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #757575;
}
::ng-deep .intro-next-tours .intro-next-tours-list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 8rem;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
}
::ng-deep .intro-next-tours .intro-next-tours-list li {
  margin: 0;
}
::ng-deep .intro-next-tours .intro-next-tours-list button {
  display: block;
  width: 100%;
  padding: 1rem;
  border: 0.0625rem solid #EBEBEB;
  border-radius: 0.375rem;
  background: #FFFFFF;
  text-align: left;
  cursor: pointer;
  transition: background 200ms ease-in-out;
}
::ng-deep .intro-next-tours .intro-next-tours-list button span {
  display: block;
  font-family: "PoppinsBold";
  font-size: 0.75rem;
  line-height: 1rem;
  color: #1E31BF;
}
::ng-deep .intro-next-tours .intro-next-tours-list button p {
  margin: 0.25rem 0 0;
  font-family: "PoppinsRegular";
  font-size: 0.675rem;
  line-height: 0.9375rem;
  color: #757575;
}
::ng-deep .intro-next-tours .intro-next-tours-list button:hover,
::ng-deep .intro-next-tours .intro-next-tours-list button:focus-visible {
  background: #F7F8FC;
  outline: none;
}
/*# sourceMappingURL=intro.component.css.map */
